<script setup>
import ColsNoLines from './ColsNoLines.vue';
import { storeToRefs } from 'pinia';
import { computed, ref } from 'vue';
import { useAuthStore } from '@/stores/auth';
import { useFixturesStore } from '@/stores/fixtures';
import { formatMarketName } from '@/helpers'

const props = defineProps({
    market: Object,
    odds: Array,
    event: Object
})

const auth = useAuthStore()
const fixtures = useFixturesStore()
const { isMarketBlocked } = storeToRefs(auth)
const { getMarket } = storeToRefs(fixtures)
const show = ref(getMarket.value(props.market.i)?.crdop)
const marketName = computed(() => formatMarketName(props.market, props.event))
</script>

<template>
    <div class="MarketGroup bg-mgc rounded overflow-hidden mt-2" v-if="getMarket(market.i)?.ac && !isMarketBlocked(market.i)">
        <div 
            class="px-2.5 py-3 cursor-pointer group"
            :class="{'border-b border-neutral-600': show}"
            @click="show = !show"
        >
            <div class="flex justify-between">
                <p class="text-[15px] text-white font-bold group-hover:text-[var(--color-primary5)]">
                    {{ marketName }}
                </p>

                <div class="mgc-Chevron hidden group-hover:block transition ease-in-out" />
            </div>
        </div>

        <div v-show="show">
            <ul class="list-none w-full">
                 <ColsNoLines 
                    :odds="odds"
                    :cols="market.c"
                    :event="event"
                    :marketId="market.i"
                    :marketNrs="market.nrs"
                />
            </ul>
        </div>
    </div>
</template>

<style scoped>
.MarketGroup:not(:has(.odd)) {
    display:none;
}

.mgc-Chevron {
    mask-image: url('/chevron-down.svg');
    background-color: var(--color-grey6);
    mask-size: 20px 20px;
    width: 20px;
    height: 20px;
}
</style>

